import { render } from "./TheAlertMessageList.vue?vue&type=template&id=00f889d1&scoped=true&ts=true&lang=html"
import script from "./TheAlertMessageList.vue?vue&type=script&lang=ts"
export * from "./TheAlertMessageList.vue?vue&type=script&lang=ts"

import "./TheAlertMessageList.vue?vue&type=style&index=0&id=00f889d1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f889d1"]])

export default __exports__